import { combineReducers } from 'redux';

import index from './index.re';
import seat from './seat.re';
import nav from './nav.re';
import relatedCinema from './relatedCinema.re';
import movieCard from './movieCard.re';
import orderDetail from './orderDetail.re';
import movieList from './movieList.re';

const rootReducer = combineReducers({
    index,
    seat,
    nav,
    relatedCinema, //  相关影院页
    movieCard,
    orderDetail,
    movieList
});

export default rootReducer;
